import React from 'react';
import InputRange from 'react-input-range';
import { UpArrow } from '../icons/Icons';

const PageTwo = (props) => {
  return (
    <div className="kids-quiz__page">

      <div className="kids-quiz__question">
        <p className="question__title">How are you feeling lately?</p>
        <div className="range__selector">
          <InputRange
            maxValue={100}
            minValue={1}
            value={props.energySliderValue}
            onChange={value => props.handleSlider(value, 'energy')}
          />
          <div className="range__text">
            <p>Really tired</p>
            <p>Full of beans</p>
          </div>
        </div>

        <div className="range__selector">
          <InputRange
            maxValue={100}
            minValue={1}
            value={props.activitySliderValue}
            onChange={value => props.handleSlider(value, 'activity')}
          />
          <div className="range__text">
            <p>Not very active</p>
            <p>Gym junkie</p>
          </div>
        </div>

        <div className="range__selector">
          <InputRange
            maxValue={100}
            minValue={1}
            value={props.sleepSliderValue}
            onChange={value => props.handleSlider(value, 'sleep')}
          />
          <div className="range__text">
            <p>Sleepless nights</p>
            <p>Sleep like a baby</p>
          </div>
        </div>

        <div className="range__selector">
          <InputRange
            maxValue={100}
            minValue={1}
            value={props.screenSliderValue}
            onChange={value => props.handleSlider(value, 'screen')}
          />
          <div className="range__text">
            <p>Minimal screen time</p>
            <p>Lots of screen time</p>
          </div>
        </div>
      </div>

      <a href="#workout" className="question-divider question-divider--show">
        <UpArrow />
      </a>

      <div id="workout" className="kids-quiz__question kids-quiz__question--show">
        <p className="question__title">When you exercise, what do you do?</p>
        <div className="answers-row--flex">
          {props.renderExerciseAnswers}
        </div>
      </div>

      <a href="#travel" className={`question-divider ${props.exerciseAnswersIndex.length > 0 ? 'question-divider--show' : ''}`}>
        <UpArrow />
      </a>

      <div id="travel" className={`kids-quiz__question ${props.exerciseAnswersIndex.length > 0 ? 'kids-quiz__question--show' : 'kids-quiz__question--hidden'}`}>
        <p className="question__title">How often do you travel internationally each year?</p>
        <div className="answers-row--flex">
          {props.renderTravelAnswers}
        </div>
      </div>

      <div className={`next-page ${props.travelAnswersIndex.length > 0 ? 'next-page--show' : 'next-page--hidden'}`} onClick={() => props.nextPage('2')}>Continue</div>
    </div>
  );
}

export default PageTwo;